export const APP_MODAL = 'AppModal'
export const APP_TRAY = 'AppTray'
export const FLY_IN = 'FlyIn'

// Modals
export const CONFIRMATION_MODAL = 'ConfirmationModal'
export const DELETE_IMAGES_MODAL = 'DeleteImagesModal'
export const UPLOAD_IMAGES_MODAL = 'UploadImagesModal'
export const UPLOAD_IMAGES_PREVIEW_MODAL = 'UploadImagesPreviewModal'
export const EVENT_DELETE_MODAL = 'EventDeleteModal'
export const USER_DELETE_MODAL = 'UserDeleteModal'
export const EVENT_RESET_MODAL = 'EventResetModal'
export const EVENT_UPGRADE_MODAL = 'EventUpgradeModal'
export const REMOVE_CONNECTOR_MODAL = 'RemoveConnectorModal'
export const ADMIN_DISCOUNT_CODE_MODAL = 'AdminDiscountCodeModal'
export const RESET_CUSTOM_EVENT_SORTING_CONFIRMATION_MODAL = 'ResetCustomEventSortingConfirmationModal'
export const DELETE_IMAGE_COMMENT_CONFIRMATION_MODAL = 'DeleteImageCommentConfirmationModal'
export const LOGIN_MODAL = 'LoginModal'
export const EVENT_EXTEND_MODAL = 'EventExtendModal'
export const IMAGE_COMMENT_EDIT_MODAL = 'ImageCommentEditModal'
export const IOS_UPLOAD_WARNING_MODAL = 'IosUploadWarningModal'
export const IOS_DOWNLOAD_CHOICE_MODAL = 'IosDownloadChoiceModal'
export const ALBUM_DELETE_MODAL = 'AlbumDeleteModal'
export const MOVE_TO_ALBUM_MODAL = 'MoveToAlbumModal'
export const GUESTBOOK_COMPOSER_MODAL = 'GuestbookComposerModal'

// Fly in's
export const GENERAL_NAVIGATION_FLY_IN = 'GeneralNavigationFlyIn'
export const ACCOUNT_NAVIGATION_FLY_IN = 'AccountNavigationFlyIn'

// Trays
export const SORT_MEDIA_CONTROLS_TRAY = 'SortMediaControlsTray'
export const SELECT_MEDIA_CONTROLS_TRAY = 'SelectMediaControlsTray'
export const SORT_MODE_TRAY = 'SortModeTray'
